<div class="thp-container">
  <app-talent-happy-path-header [headerText]="headerText"></app-talent-happy-path-header>
  <div class="thp-container-body">
    <div class="thp-message wide-container">
      <h3>{{ titleText }}</h3>
      <p [ngStyle]="{'white-space': isGather? 'pre-line' : ''}" *ngIf="showMessageText()">{{ messageText }}</p>
    </div>
    <div class="button-container" *ngIf="(talentHappyPathDataService.isGeneralApplication || isFromNotAFit) && showMessageText()">
      <button id="go-to-myaquent" mat-flat-button class="custom-button" (click)="navigateToMat()">
        {{ "talent-happy-path.buttons.go-to-myaquent" | translate }}
      </button>
      <button id="explore-jobs" mat-button class="later-button" (click)="navigateToJobBoard()">
        {{ "talent-happy-path.buttons.explore-jobs" | translate }}
      </button>
    </div>
  </div>
  <app-talent-happy-path-footer [postingInfo]="postingInfo" class="thp-footer"></app-talent-happy-path-footer>
</div>
